import gql from 'graphql-tag';

const MOVE_WORK_IN_PROJECT_CATEGORY = gql`
  mutation moveWorkInProjectCategory (
    $workId: Float!
    $projectId: Float!
    $newCategoryId: Float
    $newSortOrder: Float!
  ) {
    moveWorkInProjectCategory (
      workId: $workId
      projectId: $projectId
      newCategoryId: $newCategoryId
      newSortOrder: $newSortOrder
    )
  }
`;

export default MOVE_WORK_IN_PROJECT_CATEGORY;
